import { ReactNode } from 'react';
import usePageHeader from '~/utils/hooks/usePageHeader';

type Props = { title: string; children: ReactNode };

const PageShell = ({ title, children }: Props) => {
  usePageHeader(title);
  return <>{children}</>;
};

export default PageShell;
